<script>
  import { onMount } from "svelte";

  export let block;

  const url = block?.primary?.clickup;
</script>

<svelte:head>
  {#if url}
    <script
      async
      src="https://app-cdn.clickup.com/assets/js/forms-embed/v1.js"
    ></script>
  {/if}
</svelte:head>
{#if url}
  <div class="p-16">
    <iframe
      class="clickup-embed clickup-dynamic-height bg-transparent h-[1000px]"
      src={url}
      onwheel={() => {}}
      title="Clickup Form"
      width="100%"
      height="100%"
    >
      <p>Your browser does not support iframes.</p>
    </iframe>
  </div>
{/if}
